export class Provider {
    id: number;
    name: string;
    type: string;
    enabled: boolean;
    secure: boolean;
    attributes: {};
    isConnected: boolean;
}
